var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { setHours, setMinutes, addDays } from 'date-fns';
import { faCloudDownload } from '@fortawesome/pro-duotone-svg-icons/faCloudDownload';
import { faCopy } from '@fortawesome/pro-duotone-svg-icons/faCopy';
import { P } from '@project/components/base';
import * as actions from '@project/store/builds/actions';
import { selectBuildsDomain } from '@project/store/builds/selectors';
import Modal from '../../../../components/Modal';
import SubtleLoader from '../../../../components/Loaders/SubtleLoader';
import DatePicker from '../../../../components/Forms/Fields/DatePicker';
import { Button } from '../../../../components/Button/button.element';
import { debounce } from '../../../../utils';
var DownloadLinkModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, buildId = _a.buildId, fetchDownloadLink = _a.fetchDownloadLink, _b = _a.build, downloadLink = _b.downloadLink, downloadLink_loading = _b.downloadLink_loading, downloadLink_error = _b.downloadLink_error, expiry = _b.expiry;
    var durationFromStorage = localStorage.getItem('duration');
    var timeArray = Array.from({ length: 24 }, function (_, k) { return k; });
    var _c = useState(durationFromStorage
        ? moment().add(JSON.parse(durationFromStorage), 'seconds')
        : moment().add(1, 'hours')), selectedDate = _c[0], setSelectedDate = _c[1];
    var excludeArray = [];
    var hour = moment().hour();
    if (moment().isSame(selectedDate, 'day')) {
        excludeArray = timeArray
            .filter(function (t) { return t <= hour; })
            .map(function (t) { return setHours(setMinutes(new Date(), 0), t); });
    }
    if (moment().add(7, 'day').isSame(selectedDate, 'day')) {
        excludeArray = timeArray
            .filter(function (t) { return t >= hour; })
            .map(function (t) { return setHours(setMinutes(new Date(), 0), t); });
    }
    var _d = useState(durationFromStorage ? JSON.parse(durationFromStorage) : 3600), duration = _d[0], setDuration = _d[1];
    useEffect(function () {
        if (buildId) {
            fetchDownloadLink(buildId, duration);
        }
        localStorage.setItem('duration', JSON.stringify(duration));
    }, [buildId, duration, fetchDownloadLink]);
    var handleDownload = function () {
        window.open(downloadLink, downloadLink);
    };
    var copyToClipboard = function () {
        navigator.clipboard.writeText(downloadLink);
    };
    var handleTimeChange = debounce(function (value) {
        if (moment(value).isAfter(moment().add(1, 'hours'))) {
            setSelectedDate(moment(value));
            setDuration(Math.round(moment.duration(moment(value).diff(moment())).asSeconds()));
        }
        else {
            setSelectedDate(moment().add(1, 'hours'));
            setDuration(Math.round(moment.duration(moment().add(1, 'hours').diff(moment())).asSeconds()));
        }
    }, 750);
    return (_jsx(Modal, __assign({ open: open, onClose: onClose, headerTitle: "Download App", footerContent: _jsxs(_Fragment, { children: [_jsx(Button, __assign({ onClick: copyToClipboard, disable: !downloadLink, iconRight: _jsx(SubtleLoader, { style: { marginTop: 5, marginBottom: 5 }, color: "white", loading: downloadLink_loading, doneIcon: faCopy }) }, { children: "Copy Link" })), _jsx(Button, __assign({ onClick: handleDownload, disable: !downloadLink, style: { marginLeft: 5 }, iconRight: _jsx(SubtleLoader, { style: { marginTop: 5, marginBottom: 5 }, color: "white", loading: downloadLink_loading, doneIcon: faCloudDownload }) }, { children: downloadLink_loading ? 'Generating...' : 'Download' }))] }) }, { children: _jsxs(_Fragment, { children: [_jsx("p", { children: " Download link expiry " }), _jsx(DatePicker, { autoWidth: true, disabled: false, date: selectedDate, timeIntervals: 60, excludeTimes: excludeArray, minDate: moment().toDate(), maxDate: addDays(new Date(), 7), onChange: function (value) { return handleTimeChange(value); } }), downloadLink_loading && (_jsx(P, __assign({ fontSize: 0.8, style: { marginBottom: 0 } }, { children: "Generating..." }))), downloadLink_error && (_jsx(P, __assign({ fontSize: 0.8, style: { marginBottom: 0 } }, { children: "Failed to generate download link" }))), !downloadLink_loading && !downloadLink_error && (_jsxs(P, __assign({ fontSize: 0.8, style: { marginBottom: 0 } }, { children: ["Secure download link generated (expires", ' ', moment.unix(expiry).from(moment()), ")."] })))] }) })));
};
var mapStateToProps = function (state) { return ({
    build: selectBuildsDomain(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    fetchDownloadLink: function (buildId, duration) {
        return dispatch(actions.fetchDownloadLink(buildId, duration));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(DownloadLinkModal);
